export default "__VITE_ASSET__DS4yH4bX__"